export default __webpack_public_path__ + "static/media/l_bg.af7fbe73.jpg";